import React from 'react'
import { Box, CircularProgress, Container } from '@mui/material'

const Loading = () => {
  return (
    <Box>
      <Container sx={{mt: 100, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh',}}>
        <CircularProgress />
      </Container>
    </Box>
  )
}

export default Loading
